<template>
  <main>
    <div class="courses-page">
      <div class="section-frame">
        <ul class="breadcrumbs" v-if="quizInfo && quizInfo.quiz">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/user">{{ $t("my_office") }}</router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link
              :to="`/certified/${quizInfo.quiz.certificated_course}`"
              >{{ quizInfo ? quizInfo.title : "............" }}</router-link
            >
          </li>
        </ul>
      </div>
      <div class="courses-main-info">
        <div class="section-frame">
          <div class="courses-main-content">
            <div class="page-sub-title sub-title-white courses-title">
              <div class="courses-title-star">
                <h1>
                  <i class="fa-title"></i>
                  {{ quizHeader ? quizHeader.quiz.title : "............" }}
                </h1>
              </div>
              <p>{{ quizHeader ? quizHeader.quiz.topic : "............" }}</p>
            </div>
            <div class="courses-data-frame courses-single-data-frame">
              <p class="courses-main-data">
                {{ $t("questions_count")
                }}<span>{{
                  quizHeader ? quizHeader.quiz.questions_count : "............"
                }}</span>
              </p>
              <p class="courses-main-data">
                {{ $t("attempts_count") }}
                <span>{{
                  quizHeader ? quizHeader.quiz.chances.your_chances : "..."
                }}</span>
                /{{
                  quizHeader ? quizHeader.quiz.chances.total_chances : "..."
                }}
              </p>
              <!-- Quiz countdown timer (only visible while test is in progress) -->
              <div
                v-if="timeLeftSeconds !== null && !isShowResult"
                class="quiz-timer-display"
                :style="timerContainerStyle"
              >
                <span style="font-size:13px; opacity:0.8;">⏱</span>
                <span :style="timerStyle">{{ formatTime(timeLeftSeconds) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="courses-content" v-if="!isShowResult">
        <div class="section-frame">
          <div class="courses-test">
            <ul class="courses-test-counter" v-if="quiz">
              <li
                v-for="q in quiz.last_page"
                :key="q"
                :class="{ 'active-step': quiz.page === q }"
                @click="getPage(q)"
              >
                {{ q }}
              </li>
            </ul>
            <div class="courses-test-question">
              <div class="courses-title-frame cart-title courses-test-title">
                <i class="fa-title"></i>
                <h2 v-if="quiz && quiz.result">{{ quiz.result[0].title }}</h2>
              </div>
              <div class="test-question-list" v-if="quiz">
                <div
                  v-for="(qu, index) in quiz.result[0].answers"
                  :key="qu.id"
                  class="test-question-item"
                >
                  <div
                    class="cart-ckeck question-ckeck"
                    @click.prevent="resPush(qu.id)"
                    :class="{ 'cart-ckeck-active': qu.status }"
                  >
                    <div class="cart-ckeck-icon"></div>
                    <p>
                      <b>{{ index + 1 }}.</b> {{ qu.title }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="courses-test-btn" v-if="quiz">
              <a
                href="#"
                @click.prevent="getPage('prev')"
                class="courses-test-arrow"
                :class="{ op: quiz.page === 1 }"
                ><i class="fa-arrow-line-back"></i>
                {{ $t("previous_question") }}</a
              >
              <a
                href="#"
                v-if="quiz.page === quiz.last_page && res"
                class="courses-test-reply success"
                @click.prevent="submitAnswer"
                >{{ $t("finish_test") }} <i class="fa-check"></i
              ></a>
              <a
                href="#"
                @click.prevent="getPage('next')"
                class="courses-test-arrow"
                v-if="quiz.last_page !== quiz.page"
                >{{ $t("next_question") }}<i class="fa-arrow-line"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="courses-content" v-else>
        <div class="section-frame" v-if="quizInfo && quizInfo.quiz">
          <!-- Congratulations Message for Certificated Course Completion -->
          <div
            v-if="
              quizInfo.quiz.takers.score &&
              quizInfo.quiz.takers.completed &&
              hasSubmitQuizCertificate
            "
            class="certificate-success-message"
            style="
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              border-radius: 12px;
              padding: 40px;
              margin-bottom: 30px;
              color: white;
              text-align: center;
            "
          >
            <div style="font-size: 48px; margin-bottom: 20px">🎉</div>
            <h2
              style="
                font-size: 32px;
                font-weight: bold;
                margin-bottom: 15px;
                color: white;
              "
            >
              {{ $t("congratulations") }}
            </h2>
            <p
              style="
                font-size: 20px;
                margin-bottom: 10px;
                color: white;
                opacity: 0.95;
              "
            >
              {{ $t("course_completed") }}
            </p>
            <div
              style="
                background: rgba(255, 255, 255, 0.2);
                border-radius: 8px;
                padding: 20px;
                margin: 25px auto;
                max-width: 500px;
              "
            >
              <div
                style="
                  font-size: 18px;
                  font-weight: 600;
                  margin-bottom: 10px;
                  color: white;
                "
              >
                ✓ {{ $t("certificate_received") }}
              </div>
              <p
                style="
                  font-size: 14px;
                  color: white;
                  opacity: 0.9;
                  line-height: 1.6;
                "
              >
                {{ $t("certificate_notification") }}
              </p>
            </div>
            <div
              style="
                display: flex;
                gap: 15px;
                justify-content: center;
                margin-top: 30px;
                flex-wrap: wrap;
              "
            >
              <router-link
                to="/certificates"
                class="courses-btn"
                style="
                  background: white;
                  color: #667eea;
                  padding: 15px 30px;
                  border-radius: 8px;
                  font-weight: 600;
                  text-decoration: none;
                  display: inline-flex;
                  align-items: center;
                  gap: 8px;
                "
              >
                <svg
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                  />
                </svg>
                <div>{{ $t("go_to_profile") }}</div>
              </router-link>
              <a
                v-if="
                  submitQuizData &&
                  submitQuizData.certificates &&
                  submitQuizData.certificates.pdf
                "
                :href="submitQuizData.certificates.pdf"
                target="_blank"
                class="courses-btn"
                style="
                  background: rgba(255, 255, 255, 0.3);
                  color: white;
                  padding: 15px 30px;
                  border-radius: 8px;
                  font-weight: 600;
                  text-decoration: none;
                  display: inline-flex;
                  align-items: center;
                  gap: 8px;
                  border: 2px solid white;
                "
              >
                <svg
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                  />
                  <path
                    d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                  />
                </svg>
                <div>{{ $t("view_certificate") }}</div>
              </a>
            </div>
          </div>

          <div
            class="courses-test-btn"
            v-if="quizInfo.quiz.takers.score && quizInfo.quiz.takers.completed"
          >
            <p class="courses-test-arrow">
              <b style="font-size: 22px; color: #33ec72">{{
                quizInfo.quiz.takers.score
              }}</b>
              / 100
            </p>
            <a href="#!" class="courses-test-reply success" @click.prevent>
              {{ $t("passed_test") }}
            </a>
          </div>
          <div
            class="courses-test-btn"
            v-else-if="
              quizInfo.quiz.takers.score && !quizInfo.quiz.takers.completed
            "
          >
            <p class="courses-test-arrow">
              <b style="font-size: 22px; color: tomato"
                >{{ quizInfo.quiz.takers.score }}
              </b>
              / 100
            </p>
            <a
              href="#!"
              class="courses-test-reply"
              style="width: 280px"
              @click.prevent="startTest()"
              >{{ $t("retake_test") }} <i class="fa-arrow-line"></i
            ></a>
          </div>

          <div class="courses-home-bar" v-else>
            <a href="#!" class="courses-test-start" @click.prevent="startTest()"
              ><i class="fa-play"></i> {{ $t("start") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      res: null,
      isShowResult: true,
      timeLeftSeconds: null,
      timerInterval: null,
      isSubmitting: false,
    };
  },
  async beforeCreate() {
    await this.$store.dispatch("getQuizBySlug", this.$route.params.slug);
    await this.$store.dispatch("getQuizByIdHeader", {
      slug: this.$route.params.slug,
    });
    await this.$store.dispatch("getQuizById", {
      slug: this.$route.params.slug,
      page: 1,
    });
  },
  mounted() {
    if (this.quizInfo) {
      this.initTimer();
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  watch: {
    quizInfo(val) {
      if (val && this.timeLeftSeconds === null) {
        this.initTimer();
      }
    },
  },
  methods: {
    startTest() {
      this.isShowResult = false;
    },
    stopTest() {
      this.isShowResult = true;
    },
    initTimer() {
      if (!this.quizInfo || !this.quizInfo.quiz || !this.quizInfo.quiz.takers) return;
      if (this.quizInfo.quiz.takers.completed) return;

      const timeLeftSeconds = this.quizInfo.quiz.takers.time_left_seconds;
      if (timeLeftSeconds === undefined || timeLeftSeconds === null) return;

      this.timeLeftSeconds = timeLeftSeconds;

      if (this.timeLeftSeconds <= 0) {
        this.handleTimeUp();
        return;
      }

      this.timerInterval = setInterval(() => {
        if (this.timeLeftSeconds > 0) {
          this.timeLeftSeconds--;
        }
        if (this.timeLeftSeconds <= 0) {
          this.clearTimer();
          this.handleTimeUp();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    handleTimeUp() {
      if (!this.isShowResult) {
        // User is actively taking the test — auto-submit
        this.submitAnswer();
      } else {
        // Timer expired while on result screen — just clear timer
        this.timeLeftSeconds = 0;
      }
    },
    formatTime(seconds) {
      if (seconds <= 0) return "00:00";
      const m = Math.floor(seconds / 60);
      const s = seconds % 60;
      return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    },
    async resPush(id) {
      let answers = [];
      this.res = id;

      // Update answer status with proper reactivity
      this.quiz.result[0].answers.forEach((e) => {
        if (this.quiz.result[0].technique === "Single Choice") {
          // For single choice, set all to false, then set selected to true
          this.$set(e, "status", false);
        }
      });

      // Set the clicked answer to true for single choice
      if (this.quiz.result[0].technique === "Single Choice") {
        const selectedAnswer = this.quiz.result[0].answers.find(
          (e) => e.id === this.res,
        );
        if (selectedAnswer) {
          this.$set(selectedAnswer, "status", true);
        }
      } else if (this.quiz.result[0].technique === "Multiple Choice") {
        // For multiple choice, toggle the clicked answer
        const clickedAnswer = this.quiz.result[0].answers.find(
          (e) => e.id === this.res,
        );
        if (clickedAnswer) {
          this.$set(clickedAnswer, "status", !clickedAnswer.status);
        }
      }

      // Collect selected answers
      let obj = {
        question: null,
        answer: null,
      };
      this.quiz.result[0].answers.forEach((answer) => {
        if (answer.status) {
          answers.push(answer.id);
        }
      });

      // Only validate if we're trying to save/submit, not just selecting an answer
      if (answers.length > 0) {
        obj.answer = answers.toString();
        obj.question = this.quiz.result[0].id;
        await this.$store.dispatch("getQuizSaveAnswer", obj);
      }

      obj = {
        question: null,
        answer: null,
      };
      if (this.quiz.page !== this.quiz.last_page) {
        this.res = null;
      }
    },
    getPage(page) {
      if (page === "prev") {
        this.$store.dispatch("getQuizById", {
          slug: this.$route.params.slug,
          page: this.quiz.page - 1,
        });
      }
      if (page === "next") {
        this.$store.dispatch("getQuizById", {
          slug: this.$route.params.slug,
          page: this.quiz.page + 1,
        });
      } else {
        this.$store.dispatch("getQuizById", {
          slug: this.$route.params.slug,
          page: page,
        });
      }
    },

    async submitAnswer() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.clearTimer();
      await this.$store.dispatch("submitQuiz", this.$route.params.slug);
      await this.$store.dispatch("getQuizBySlug", this.$route.params.slug);
      this.stopTest();
    },
  },
  computed: {
    quiz() {
      return this.$store.getters.getQuiz;
    },
    quizHeader() {
      return this.$store.getters.getQuizHeader;
    },
    quizInfo() {
      return this.$store.getters.getQuizInfo;
    },
    submitQuizData() {
      return this.$store.getters.getSubmitQuiz;
    },
    hasSubmitQuizCertificate() {
      return this.submitQuizData && this.submitQuizData.certificates;
    },
    timerContainerStyle() {
      return {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        background: 'rgba(255,255,255,0.15)',
        borderRadius: '8px',
        padding: '6px 14px',
        marginLeft: '8px',
      };
    },
    timerStyle() {
      if (this.timeLeftSeconds === null) return {};
      const base = { fontSize: '22px', fontWeight: '700', letterSpacing: '1px' };
      if (this.timeLeftSeconds <= 30) {
        return { ...base, color: '#ff4444', animation: 'pulse 0.8s infinite' };
      }
      if (this.timeLeftSeconds <= 60) {
        return { ...base, color: '#ffaa00' };
      }
      return { ...base, color: '#ffffff' };
    },
  },
};
</script>

<style scoped>
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
</style>
